import { Users } from "lucide-react";
import {
  StakeholderMapParamsSchema,
  defaultStakeholderMapParams,
  type StakeholderMapParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { StakeholderMapWidget } from "./Component.js";

export const stakeholderMapDef: WidgetDef<StakeholderMapParams> = {
  kind: "stakeholderMap",
  label: "Stakeholder Map",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 752, h: 384 },
  defaultParams: defaultStakeholderMapParams,
  Component: StakeholderMapWidget,
  storage: "sql",
  schema: StakeholderMapParamsSchema,
  accent: "rose",
  icon: Users,
  subtitle: "Power × Interest grid",
  defaultRoster: false, // addable from "+ Widget" only
  category: "multi",
  layout: { col: "full", row: 2, width: 752, height: 360 },
  expandable: true,
  headerAffordance: { label: "Add stakeholder", action: "body" },
  renderFooter: (data) => ({
    left: `${data.stakeholders.length} stakeholder${data.stakeholders.length === 1 ? "" : "s"}`,
    right: "Power × Interest",
  }),
};

registerWidget(stakeholderMapDef);
